import * as React from 'react';
import { Descriptions } from 'antd';
import { Wrapper } from './styled';
import { Retry } from '@src/components/common';
import moment from 'moment';
import { SERVICE_INT_DATE_FORMAT } from '@src/utils/constants';
import Table from '@src/components/common/Table';

const HistoryContent = ({ webhook, data = null, isLoading, error }) => {
  const columns = [
    {
      title: 'User Name',
      width: 250,
      dataKey: 'userName',
      key: 'userName',
    },
    {
      title: 'Last Modified',
      width: 250,
      dataKey: 'lastModified',
      key: 'lastModified',
      cellRenderer: ({ cellData }) =>
        cellData ? moment(cellData).format(SERVICE_INT_DATE_FORMAT) : null,
    },
    {
      title: 'Changes',
      width: 500,
      flexGrow: 1,
      dataKey: 'changes',
      key: 'changes',
    },
  ];
  return (
    <>
      <Descriptions>
        <Descriptions.Item span={4} label="Webhook Name" style={{ padding: '5px 0' }}>
          {webhook.name}
        </Descriptions.Item>
        <Descriptions.Item span={4} label="URL">
          {webhook.webhookUrl}
        </Descriptions.Item>
      </Descriptions>
      <Wrapper>
        {isLoading ? (
          <Retry isLoading={isLoading} showError={!!error} />
        ) : (
          <Table
            data={data}
            columns={columns}
            headerHeight={50}
            rowHeight={130}
            rowKey="key"
            expandColumnKey={'changes'}
          />
        )}
      </Wrapper>
    </>
  );
};

export default HistoryContent;
